module.exports = __webpack_public_path__ + "img/wjk.4cca268d.png";